import React, { useEffect, useRef, useState } from "react";

const LoadCompleteImage = ({
  alt = "",
  className = "",
  onLoad,
  onError,
  revealImmediately = false,
  src,
  ...props
}) => {
  const imageRef = useRef(null);
  const [loaded, setLoaded] = useState(revealImmediately);

  useEffect(() => {
    setLoaded(revealImmediately);
  }, [src, revealImmediately]);

  useEffect(() => {
    if (revealImmediately) {
      setLoaded(true);
      return undefined;
    }

    const image = imageRef.current;
    if (image?.complete && image.naturalWidth > 0) {
      setLoaded(true);
      return;
    }

    const fallbackTimer = window.setTimeout(() => {
      const currentImage = imageRef.current;
      if (currentImage?.complete && currentImage.naturalWidth > 0) {
        setLoaded(true);
      }
    }, 300);

    return () => window.clearTimeout(fallbackTimer);
  }, [src, revealImmediately]);

  const handleLoad = (event) => {
    setLoaded(true);
    onLoad?.(event);

    const image = event.currentTarget;
    if (image.decode) {
      image.decode().catch(() => {
        // A decode rejection should not leave a successfully loaded image hidden.
      });
    }
  };

  const handleError = (event) => {
    setLoaded(true);
    onError?.(event);
  };

  return (
    <img
      ref={imageRef}
      {...props}
      src={src}
      alt={alt}
      className={`${className} load-complete-image ${
        loaded ? "is-loaded" : ""
      }`.trim()}
      onLoad={handleLoad}
      onError={handleError}
    />
  );
};

export default LoadCompleteImage;
